import React from 'react';
import {hasFeatureFlag} from '../../util/FeatureUtil';
import {deriveEligibilityFromTask} from './eligibility';
import {NovaInvocationControl} from './NovaInvocationControl';
import {useNovaInvocationState} from './useNovaInvocationState';

export interface ConnectedNovaInvocationControlProps {
	taskId: string;
	// See InvocationControlProps.instanceKey (NovaInvocationControl.tsx) — must match whatever
	// key the agentPicker prop below was itself given.
	instanceKey?: string;
	readOnly: boolean;
	onOpenTask: () => void;
	agentPicker?: React.ReactNode;
}

export const ConnectedNovaInvocationControl = (props: ConnectedNovaInvocationControlProps): JSX.Element | null => {
	const isEnabled = hasFeatureFlag('nova_agent_invocation');
	const eligibility = deriveEligibilityFromTask({readOnly: {isReadOnly: props.readOnly}});
	// Hooks run unconditionally on every render — Rules of Hooks forbids skipping the call itself
	// — but passing isEnabled through lets the hook skip its own store subscriptions when the flag
	// is off, so a flag-off account isn't paying for work behind a control that renders null anyway.
	const {state, onAction, onOpenOutput} = useNovaInvocationState(props.taskId, eligibility, isEnabled);

	if (!isEnabled) return null;

	return (
		<NovaInvocationControl
			taskId={props.taskId}
			instanceKey={props.instanceKey}
			state={state}
			onAction={onAction}
			onOpenOutput={() => {
				onOpenOutput();
				props.onOpenTask();
			}}
			agentPicker={props.agentPicker}
		/>
	);
};
